<template>
  <main-template>
    <div class="home-page" style="padding-bottom: 5%">
      <!-- Avisos Banner -->
      <v-row
        v-if="mostrarAvisos && avisosColaborador && avisosColaborador.length > 0"
        class="mb-4 animate-item a1"
      >
        <v-col cols="12">
          <v-card
            v-for="aviso in avisosColaborador"
            :key="aviso.id"
            color="#4f008f"
            dark
            class="aviso-banner pa-4 rounded-xl d-flex flex-wrap align-center justify-space-between mb-3 position-relative overflow-hidden"
            style="border: none !important"
            elevation="2"
          >
            <div class="d-flex align-center flex-grow-1 flex-wrap" style="z-index: 1">
              <v-avatar size="80" rounded class="mr-4 mb-2 mb-sm-0 elevation-1" v-if="aviso.imagem">
                <img
                  :src="obterUrlImagemAviso(aviso.imagem)"
                  alt="Aviso"
                  style="object-fit: cover"
                />
              </v-avatar>

              <div class="flex-grow-1">
                <div class="text-h6 font-weight-black d-flex align-center">
                  <v-icon left color="amber" class="mr-2">mdi-alert-decagram-outline</v-icon>
                  {{ aviso.titulo }}
                </div>
                <div class="text-body-1 mt-1 font-weight-medium white--text text--lighten-4">
                  {{ aviso.conteudo }}
                </div>
              </div>
            </div>
          </v-card>
        </v-col>
      </v-row>

      <!-- Cabeçalho da página -->
      <v-row align="center" class="mb-4 animate-item a1">
        <v-col cols="12" md="8">
          <div class="d-flex align-center">
            <v-avatar size="52" class="badge-gradient mr-3 page-icon-avatar" elevation="0">
              <v-icon large>mdi-view-dashboard-outline</v-icon>
            </v-avatar>
            <div>
              <div class="page-title font-weight-black grey--text text--darken-3">
                Folha de Pontos &amp; Banco de Horas
              </div>
              <div class="page-subtitle grey--text text--darken-1">
                Acompanhamento inteligente de desempenho, jornadas e gestão da equipe.
              </div>
            </div>
          </div>
        </v-col>
        <v-col cols="12" md="4" class="text-md-right">
          <v-chip v-if="isGestor" color="var(--brand)" outlined class="font-weight-bold role-pill">
            <v-icon left small>mdi-shield-account-outline</v-icon>
            Painel de Gestão ({{ isAdmin ? "Admin" : "Direção / Coordenador" }})
          </v-chip>
          <v-chip v-else color="teal darken-1" outlined class="font-weight-bold role-pill">
            <v-icon left small>mdi-account-outline</v-icon>
            Painel do Colaborador
          </v-chip>
        </v-col>
      </v-row>

      <!-- Bloco 1: Banco de Horas + Gestão -->
      <div
        v-if="mostrarMeuBancoHoras || mostrarGestaoBancoHoras"
        class="summary-row animate-item a2"
      >
        <template v-if="isAdmin && mostrarGestaoBancoHoras">
          <v-card outlined rounded="xl" class="summary-card summary-type-bank">
            <div class="summary-accent"></div>
            <div class="summary-body pa-4 pa-lg-5 d-flex flex-column flex-grow-1">
              <div class="d-flex justify-space-between align-start flex-wrap summary-header">
                <div class="d-flex align-center min-w-0">
                  <div class="summary-badge flex-shrink-0">
                    <v-icon>mdi-account-group-outline</v-icon>
                  </div>
                  <div class="min-w-0">
                    <div class="summary-title text-truncate">Banco de Horas da Equipe</div>
                    <div class="summary-subtitle text-truncate">
                      Saúde consolidada do banco de horas da instituição
                    </div>
                  </div>
                </div>
                <v-chip
                  color="var(--brand)"
                  outlined
                  small
                  class="font-weight-bold text-capitalize summary-pill"
                >
                  <v-icon x-small left>mdi-account-group-outline</v-icon>
                  Visão Geral
                </v-chip>
              </div>

              <div class="summary-hero mt-4">
                <div class="summary-hero-label">Colaboradores Acompanhados</div>
                <div class="summary-hero-value">{{ saldosEquipeTotal }}</div>
                <div class="summary-hero-caption">Saldos e jornadas monitorados na instituição</div>
              </div>

              <div class="summary-metrics">
                <div class="summary-metric">
                  <div class="summary-metric-icon is-green">
                    <v-icon x-small>mdi-emoticon-happy-outline</v-icon>
                  </div>
                  <div class="min-w-0">
                    <div class="summary-metric-label">Com Saldo Positivo</div>
                    <div class="summary-metric-value is-green">
                      {{ totalPositivos }} colaborador(es)
                    </div>
                  </div>
                </div>
                <div class="summary-metric">
                  <div class="summary-metric-icon is-amber">
                    <v-icon x-small>mdi-sync</v-icon>
                  </div>
                  <div class="min-w-0">
                    <div class="summary-metric-label">Em Compensação</div>
                    <div class="summary-metric-value is-amber">
                      {{ totalNegativos }} colaborador(es)
                    </div>
                  </div>
                </div>
              </div>

              <div class="summary-footer">
                <v-icon x-small class="mr-1" color="grey darken-1">mdi-update</v-icon>
                Saldos atualizados em tempo real
              </div>

              <div class="mt-4">
                <v-btn
                  block
                  color="#4f008f"
                  dark
                  rounded
                  class="text-capitalize font-weight-bold gestao-action-btn"
                  @click="$router.push({ name: 'colaboradores.bancoHoras.gerenciar' })"
                >
                  <v-icon left>mdi-account-cog-outline</v-icon>
                  Ir para Gestão do Banco de Horas
                </v-btn>
              </div>
            </div>
          </v-card>

          <v-card outlined rounded="xl" class="summary-card summary-type-gestao">
            <div class="summary-accent"></div>
            <div class="summary-body pa-4 pa-lg-5 d-flex flex-column flex-grow-1">
              <div class="d-flex justify-space-between align-start flex-wrap summary-header">
                <div class="d-flex align-center min-w-0">
                  <div class="summary-badge flex-shrink-0">
                    <v-icon>mdi-account-clock-outline</v-icon>
                  </div>
                  <div class="min-w-0">
                    <div class="summary-title text-truncate">Gestão de Horas Extras</div>
                    <div class="summary-subtitle text-truncate">Aprovações da equipe pendentes</div>
                  </div>
                </div>
                <v-chip
                  v-if="pendenciasBancoHorasTotal > 0"
                  color="amber darken-3"
                  dark
                  small
                  class="font-weight-bold summary-pill"
                >
                  {{ pendenciasBancoHorasTotal }} pendente(s)
                </v-chip>
                <v-chip
                  v-else
                  color="teal darken-1"
                  dark
                  small
                  class="font-weight-bold summary-pill"
                >
                  <v-icon x-small left>mdi-check</v-icon>
                  Tudo em dia!
                </v-chip>
              </div>

              <div class="summary-hero mt-4">
                <div class="summary-hero-label">Solicitações Aguardando Aprovação</div>
                <div
                  class="summary-hero-value"
                  :class="pendenciasBancoHorasTotal > 0 ? 'is-amber' : 'is-green'"
                >
                  {{ pendenciasBancoHorasTotal }}
                </div>
                <div class="summary-hero-caption">
                  {{
                    pendenciasBancoHorasTotal > 0
                      ? "Existem solicitações de horas extras que necessitam da sua validação."
                      : "Nenhuma solicitação de horas extras pendente de análise no momento."
                  }}
                </div>
              </div>

              <div class="summary-metrics">
                <div class="summary-metric">
                  <div class="summary-metric-icon is-amber">
                    <v-icon x-small>mdi-file-clock-outline</v-icon>
                  </div>
                  <div class="min-w-0">
                    <div class="summary-metric-label">Pendentes</div>
                    <div class="summary-metric-value is-amber">
                      {{ pendenciasBancoHorasTotal }}
                    </div>
                  </div>
                </div>
                <div class="summary-metric">
                  <div
                    class="summary-metric-icon"
                    :class="pendenciasBancoHorasTotal > 0 ? 'is-amber' : 'is-green'"
                  >
                    <v-icon x-small>mdi-check-circle-outline</v-icon>
                  </div>
                  <div class="min-w-0">
                    <div class="summary-metric-label">Status</div>
                    <div
                      class="summary-metric-value"
                      :class="pendenciasBancoHorasTotal > 0 ? 'is-amber' : 'is-green'"
                    >
                      {{ pendenciasBancoHorasTotal > 0 ? "Aguardando" : "Em dia" }}
                    </div>
                  </div>
                </div>
              </div>

              <div class="summary-footer">
                <v-icon x-small class="mr-1" color="grey darken-1">mdi-update</v-icon>
                Revisado em tempo real
              </div>

              <div class="mt-4">
                <v-btn
                  block
                  color="#4f008f"
                  dark
                  rounded
                  class="text-capitalize font-weight-bold gestao-action-btn"
                  @click="$router.push({ name: 'colaboradores.bancoHoras.gerenciar' })"
                >
                  <v-icon left>mdi-file-check-outline</v-icon>
                  Ir para Gestão do Banco de Horas
                </v-btn>
              </div>
            </div>
          </v-card>
        </template>

        <template v-else>
          <v-card
            v-if="mostrarMeuBancoHoras"
            outlined
            rounded="xl"
            class="summary-card summary-type-bank"
          >
            <div class="summary-accent"></div>
            <div class="summary-body pa-4 pa-lg-5 d-flex flex-column flex-grow-1">
              <div class="d-flex justify-space-between align-start flex-wrap summary-header">
                <div class="d-flex align-center min-w-0">
                  <div class="summary-badge flex-shrink-0">
                    <v-icon>mdi-scale-balance</v-icon>
                  </div>
                  <div class="min-w-0">
                    <div class="summary-title text-truncate">Meu Banco de Horas</div>
                    <div class="summary-subtitle text-truncate">
                      Balanço atualizado e acompanhamento contínuo
                    </div>
                  </div>
                </div>
                <v-chip
                  :color="isSaldoNegativo ? 'orange darken-2' : 'teal darken-1'"
                  dark
                  small
                  class="font-weight-bold text-capitalize summary-pill"
                >
                  {{ isSaldoNegativo ? "Compensação Dinâmica" : "Saldo Positivo" }}
                </v-chip>
              </div>

              <div class="summary-hero mt-4">
                <div class="summary-hero-label">Saldo Acumulado</div>
                <div class="summary-hero-value" :class="isSaldoNegativo ? 'is-orange' : 'is-green'">
                  {{ meuSaldo.saldo_formatado || "00:00" }}
                </div>
                <div class="summary-hero-caption">
                  Saldo acompanhado de forma contínua na instituição
                </div>
              </div>

              <div class="summary-metrics">
                <div class="summary-metric">
                  <div class="summary-metric-icon is-green">
                    <v-icon x-small>mdi-plus-circle-outline</v-icon>
                  </div>
                  <div class="min-w-0">
                    <div class="summary-metric-label">Créditos Aprovados</div>
                    <div class="summary-metric-value is-green">
                      +{{ meuSaldo.horas_positivas_fmt || "00:00" }}
                    </div>
                  </div>
                </div>
                <div class="summary-metric">
                  <div class="summary-metric-icon is-amber">
                    <v-icon x-small>mdi-clock-alert-outline</v-icon>
                  </div>
                  <div class="min-w-0">
                    <div class="summary-metric-label">Horas em Análise</div>
                    <div class="summary-metric-value is-amber">
                      {{ meuSaldo.minutos_pendentes_fmt || "00:00" }}
                    </div>
                  </div>
                </div>
              </div>

              <div class="summary-footer">
                <v-icon x-small class="mr-1 mt-1" color="grey darken-1"
                  >mdi-information-outline</v-icon
                >
                "{{ mensagemInteligenteBancoHoras }}"
              </div>

              <div class="mt-4">
                <v-btn
                  block
                  color="#4f008f"
                  dark
                  rounded
                  class="text-capitalize font-weight-bold gestao-action-btn"
                  @click="$router.push({ name: 'colaboradores.bancoHoras' })"
                >
                  <v-icon left>mdi-open-in-new</v-icon>
                  Ver Detalhes do Meu Banco de Horas
                </v-btn>
              </div>
            </div>
          </v-card>

          <v-card
            v-if="mostrarGestaoBancoHoras"
            outlined
            rounded="xl"
            class="summary-card summary-type-gestao"
          >
            <div class="summary-accent"></div>
            <div class="summary-body pa-4 pa-lg-5 d-flex flex-column flex-grow-1">
              <div class="d-flex justify-space-between align-start flex-wrap summary-header">
                <div class="d-flex align-center min-w-0">
                  <div class="summary-badge flex-shrink-0">
                    <v-icon>mdi-account-clock-outline</v-icon>
                  </div>
                  <div class="min-w-0">
                    <div class="summary-title text-truncate">Gestão de Banco de Horas</div>
                    <div class="summary-subtitle text-truncate">Aprovações da equipe pendentes</div>
                  </div>
                </div>
                <v-chip
                  v-if="pendenciasBancoHorasTotal > 0"
                  color="amber darken-3"
                  dark
                  small
                  class="font-weight-bold summary-pill"
                >
                  {{ pendenciasBancoHorasTotal }} pendente(s)
                </v-chip>
                <v-chip
                  v-else
                  color="teal darken-1"
                  dark
                  small
                  class="font-weight-bold summary-pill"
                >
                  <v-icon x-small left>mdi-check</v-icon>
                  Tudo em dia!
                </v-chip>
              </div>

              <div class="summary-hero mt-4">
                <div class="summary-hero-label">Solicitações Aguardando Aprovação</div>
                <div
                  class="summary-hero-value"
                  :class="pendenciasBancoHorasTotal > 0 ? 'is-amber' : 'is-green'"
                >
                  {{ pendenciasBancoHorasTotal }}
                </div>
                <div class="summary-hero-caption">
                  {{
                    pendenciasBancoHorasTotal > 0
                      ? "Existem solicitações de horas extras que necessitam da sua validação."
                      : "Nenhuma solicitação de horas extras pendente de análise no momento."
                  }}
                </div>
              </div>

              <div class="summary-metrics">
                <div class="summary-metric">
                  <div class="summary-metric-icon is-amber">
                    <v-icon x-small>mdi-file-clock-outline</v-icon>
                  </div>
                  <div class="min-w-0">
                    <div class="summary-metric-label">Pendentes</div>
                    <div class="summary-metric-value is-amber">
                      {{ pendenciasBancoHorasTotal }}
                    </div>
                  </div>
                </div>
                <div class="summary-metric">
                  <div
                    class="summary-metric-icon"
                    :class="pendenciasBancoHorasTotal > 0 ? 'is-amber' : 'is-green'"
                  >
                    <v-icon x-small>mdi-check-circle-outline</v-icon>
                  </div>
                  <div class="min-w-0">
                    <div class="summary-metric-label">Status</div>
                    <div
                      class="summary-metric-value"
                      :class="pendenciasBancoHorasTotal > 0 ? 'is-amber' : 'is-green'"
                    >
                      {{ pendenciasBancoHorasTotal > 0 ? "Aguardando" : "Em dia" }}
                    </div>
                  </div>
                </div>
              </div>

              <div class="summary-footer">
                <v-icon x-small class="mr-1" color="grey darken-1">mdi-update</v-icon>
                Revisado em tempo real
              </div>

              <div class="mt-4">
                <v-btn
                  block
                  color="#4f008f"
                  dark
                  rounded
                  class="text-capitalize font-weight-bold gestao-action-btn"
                  @click="$router.push({ name: 'colaboradores.bancoHoras.gerenciar' })"
                >
                  <v-icon left>mdi-file-check-outline</v-icon>
                  Ir para Gestão do Banco de Horas
                </v-btn>
              </div>
            </div>
          </v-card>
        </template>
      </div>

      <!-- Gráfico de atividade -->
      <v-row v-if="mostrarGrafico" class="animate-item a3">
        <v-col cols="12">
          <v-card outlined rounded="xl" class="mx-auto chart-card">
            <v-card-title
              class="chart-header pb-0 d-flex flex-wrap align-center justify-space-between"
            >
              <div class="d-flex align-center min-w-0">
                <v-avatar size="42" class="badge-gradient mr-3 chart-icon-avatar">
                  <v-icon>mdi-chart-line</v-icon>
                </v-avatar>
                <div class="min-w-0">
                  <div
                    class="text-subtitle-1 font-weight-bold grey--text text--darken-3 text-truncate"
                  >
                    {{ tituloGrafico }}
                  </div>
                  <div class="text-caption grey--text text--darken-1">
                    {{ subtituloGrafico }}
                  </div>
                </div>
              </div>

              <div class="chart-range-pills d-flex align-center mt-2 mt-sm-0">
                <span class="text-caption grey--text text--darken-1 mr-2 d-none d-sm-inline"
                  >Período:</span
                >
                <v-chip
                  v-for="opcao in pontosRangeOptions"
                  :key="opcao.value"
                  small
                  :color="pontoRange === opcao.value ? '#4f008f' : 'grey lighten-3'"
                  :dark="pontoRange === opcao.value"
                  :outlined="pontoRange !== opcao.value"
                  class="font-weight-bold text-uppercase range-chip"
                  @click="selecionarRangePonto(opcao.value)"
                >
                  {{ opcao.label }}
                </v-chip>
              </div>
            </v-card-title>

            <v-card-text class="pb-2">
              <apexchart
                type="line"
                :height="graficoAltura"
                :options="pontoOptions"
                :series="pontoSeries"
              />
            </v-card-text>

            <v-card-text class="pt-0 pb-4">
              <div class="d-flex align-center justify-center chart-legend">
                <span class="chart-legend-item">
                  <i
                    class="legend-dot"
                    :style="{ backgroundColor: $vuetify.theme.dark ? '#a78bfa' : '#4f008f' }"
                  ></i>
                  Registros
                </span>
                <span class="chart-legend-item">
                  <i class="legend-dot" style="background-color: #49a94d"></i>
                  Incompletos
                </span>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <!-- Indicadores -->
      <v-row class="mt-2 metrics-row animate-item a4">
        <v-col cols="12" sm="6" :md="isGestor ? 3 : 4" v-if="mostrarGrafico">
          <v-card outlined rounded="xl" class="pa-5 metric-card metric-tone-registros">
            <div class="d-flex align-center justify-space-between">
              <div>
                <div class="metric-label">Registros hoje</div>
                <div class="metric-value">{{ totalBatidasHoje }}</div>
              </div>
              <div class="metric-badge">
                <v-icon>mdi-clock-check-outline</v-icon>
              </div>
            </div>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" :md="isGestor ? 3 : 4" v-if="mostrarGrafico">
          <v-card outlined rounded="xl" class="pa-5 metric-card metric-tone-incompletos">
            <div class="d-flex align-center justify-space-between">
              <div>
                <div class="metric-label">Dias incompletos</div>
                <div class="metric-value">{{ totalDiasIncompletos }}</div>
              </div>
              <div class="metric-badge">
                <v-icon>mdi-alert-circle-outline</v-icon>
              </div>
            </div>
          </v-card>
        </v-col>

        <v-col
          cols="12"
          sm="6"
          :md="isGestor ? 3 : 4"
          v-if="mostrarGrafico && mostrarFaltasJustificadas"
        >
          <v-card outlined rounded="xl" class="pa-5 metric-card metric-tone-faltas">
            <div class="d-flex align-center justify-space-between">
              <div>
                <div class="metric-label">Faltas justificadas</div>
                <div class="metric-value">{{ totalFaltasJustificadas }}</div>
              </div>
              <div class="metric-badge">
                <v-icon>mdi-file-document-check-outline</v-icon>
              </div>
            </div>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" :md="isGestor ? 3 : 4" v-if="colaboradorMaisPontual">
          <v-card outlined rounded="xl" class="pa-5 metric-card metric-tone-destaque">
            <div class="d-flex align-center justify-space-between">
              <div style="min-width: 0">
                <div class="metric-label metric-label-destaque">
                  Destaque da Semana
                  <v-icon small>mdi-trophy</v-icon>
                </div>
                <div class="metric-value-name text-truncate" :title="colaboradorMaisPontual.nome">
                  {{ colaboradorMaisPontual.nome }}
                </div>
                <div class="metric-sub">
                  {{ colaboradorMaisPontual.pontualidade }}% de pontualidade
                </div>
              </div>
              <div class="metric-badge">
                <v-icon>mdi-trophy-outline</v-icon>
              </div>
            </div>
          </v-card>
        </v-col>
      </v-row>

      <!-- Colaboradores sem registro de ponto -->
      <v-row class="mt-4 animate-item a5" v-if="mostrarSemRegistro">
        <v-col cols="12">
          <v-card outlined rounded="xl" class="pa-5 collab-card">
            <v-card-title class="px-0 pt-0 d-flex flex-wrap align-center justify-space-between">
              <div class="d-flex align-center">
                <v-avatar
                  size="44"
                  class="badge-gradient badge-gradient-rose mr-3 card-icon-avatar"
                >
                  <v-icon>mdi-account-clock-outline</v-icon>
                </v-avatar>
                <div>
                  <div class="text-h6 font-weight-black grey--text text--darken-3">
                    Colaboradores sem registro de ponto hoje
                  </div>
                  <div class="text-caption grey--text text--darken-1">
                    Lista de colaboradores que ainda não realizaram nenhum registro de ponto no dia
                    de hoje.
                  </div>
                </div>
              </div>

              <v-text-field
                v-model="searchSemBatida"
                prepend-inner-icon="mdi-magnify"
                label="Buscar colaborador..."
                single-line
                hide-details
                dense
                outlined
                rounded
                class="search-input mt-2 mt-sm-0"
                style="max-width: 300px"
              ></v-text-field>
            </v-card-title>

            <v-card-text class="px-0 pb-0">
              <v-divider class="mb-4"></v-divider>

              <div v-if="loadingSemBatida" class="d-flex justify-center align-center py-6">
                <v-progress-circular
                  indeterminate
                  color="var(--brand)"
                  size="32"
                ></v-progress-circular>
                <span class="ml-3 body-2 grey--text text--darken-1"
                  >Carregando colaboradores...</span
                >
              </div>

              <div v-else-if="filteredColaboradoresSemBatida.length === 0">
                <div class="d-flex flex-column align-center justify-center py-8 text-center">
                  <v-avatar color="var(--tint-green)" size="56" class="mb-3">
                    <v-icon color="#49A94D" size="28">mdi-check-all</v-icon>
                  </v-avatar>
                  <div class="text-subtitle-1 font-weight-bold grey--text text--darken-3">
                    {{
                      searchSemBatida
                        ? "Nenhum colaborador encontrado com esse nome"
                        : "Tudo em ordem!"
                    }}
                  </div>
                  <div class="text-caption grey--text text--darken-1 mt-1">
                    {{
                      searchSemBatida
                        ? "Tente buscar por outro nome."
                        : "Todos os colaboradores ativos já registraram ponto hoje."
                    }}
                  </div>
                </div>
              </div>

              <div v-else>
                <v-row class="ma-0">
                  <v-col
                    v-for="colab in filteredColaboradoresSemBatida"
                    :key="colab.id"
                    cols="12"
                    sm="6"
                    md="4"
                    lg="3"
                    class="pa-2"
                  >
                    <v-card outlined rounded="lg" class="pa-3 colab-item-card d-flex align-center">
                      <v-avatar color="var(--tint-rose)" size="40" class="mr-3">
                        <v-icon color="#f43f5e" size="20">mdi-account-clock</v-icon>
                      </v-avatar>
                      <div class="text-truncate">
                        <div
                          class="text-subtitle-2 font-weight-bold text-truncate grey--text text--darken-3"
                          :title="colab.name"
                        >
                          {{ colab.name }}
                        </div>
                        <div
                          class="text-caption text-uppercase font-weight-medium rose--text text--darken-1"
                          style="font-size: 0.65rem !important"
                        >
                          Ponto Ausente
                        </div>
                      </div>
                    </v-card>
                  </v-col>
                </v-row>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <e-change-password-modal :value="Boolean(user && user.forcar_troca_senha)" forced />
    </div>
  </main-template>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "HomePage",
  async created() {
    this.$loaderService.open("Carregando dados...");
    try {
      await this.$services.franquiasService.syncAll();
      await this.$store.dispatch("AppConfigurations/garantirModulos");
      // Só busca o que o perfil enxerga: módulos ocultos são recusados pela API.
      await Promise.all([
        this.mostrarGrafico ? this.loadGraficoPontos() : Promise.resolve(),
        this.loadBancoHorasDados(),
        this.mostrarSemRegistro ? this.loadColaboradoresSemBatida() : Promise.resolve(),
        this.mostrarAvisos ? this.loadAvisosColaborador() : Promise.resolve(),
        this.loadColaboradorMaisPontual(),
      ]);
    } catch (error) {
      /* eslint-disable-next-line no-console */
      console.error("Erro ao carregar dados da HomePage:", error);
    } finally {
      this.$loaderService.close();
    }
  },
  computed: {
    ...mapGetters("Auth", ["user"]),
    ...mapGetters("AppConfigurations", ["moduloAtivo"]),
    userRoles() {
      const roles = [];
      if (this.user?.roles && Array.isArray(this.user.roles)) {
        this.user.roles.forEach((r) => roles.push(r.name || r));
      }
      if (this.user?.roleName) {
        roles.push(this.user.roleName);
      }
      return roles;
    },
    isAdmin() {
      return this.userRoles.some((r) => ["super-admin", "admin"].includes(r));
    },
    isGestor() {
      return this.userRoles.some((r) => ["super-admin", "admin", "TI", "lider"].includes(r));
    },
    // Blocos condicionados aos módulos liberados (Administração > Configurações).
    mostrarAvisos() {
      return this.moduloAtivo("avisos");
    },
    mostrarMeuBancoHoras() {
      return this.moduloAtivo("meu_banco_horas");
    },
    mostrarGestaoBancoHoras() {
      return this.isGestor && this.moduloAtivo("gestao_banco_horas");
    },
    mostrarGrafico() {
      return this.moduloAtivo(this.isGestor ? "ponto_colaboradores" : "meus_pontos");
    },
    mostrarFaltasJustificadas() {
      return this.isGestor && this.moduloAtivo("aprovar_faltas");
    },
    mostrarSemRegistro() {
      return this.isGestor && this.moduloAtivo("ponto_colaboradores");
    },
    meuSaldoMinutos() {
      return this.meuSaldo?.saldo_minutos || 0;
    },
    isSaldoNegativo() {
      return this.meuSaldoMinutos < 0;
    },
    mensagemInteligenteBancoHoras() {
      const min = this.meuSaldoMinutos;
      if (min > 0) {
        return `Seu banco de horas possui um saldo positivo de ${
          this.meuSaldo.saldo_formatado || "00:00"
        } acumulado. Excelente acompanhamento de suas jornadas!`;
      }
      if (min < 0) {
        return `Seu banco de horas é dinâmico e possui ${
          this.meuSaldo.saldo_formatado || "00:00"
        } em compensação contínua à medida que você realiza suas próximas jornadas.`;
      }
      return `Seu banco de horas está totalmente equilibrado e em dia com sua escala de trabalho.`;
    },
    filteredColaboradoresSemBatida() {
      if (!this.searchSemBatida) {
        return this.colaboradoresSemBatida;
      }
      const search = this.searchSemBatida.toLowerCase();
      return this.colaboradoresSemBatida.filter((colab) =>
        colab.name.toLowerCase().includes(search)
      );
    },
    graficoAltura() {
      return this.$vuetify && this.$vuetify.breakpoint && this.$vuetify.breakpoint.smAndDown
        ? 320
        : 400;
    },
    subtituloGrafico() {
      return this.isGestor
        ? "Visão consolidada de registros e jornadas incompletas da equipe"
        : "Meus registros de ponto e jornadas incompletas nos últimos dias";
    },
    // Opções do gráfico recalculadas quando o tema (claro/escuro) ou as categorias mudam.
    pontoOptions() {
      const escuro = this.$vuetify.theme.dark;
      const corEixo = escuro ? "#9a93ad" : "#64748b";
      const corGrade = escuro ? "#353046" : "#e2e8f0";
      const linhasGrade = escuro
        ? ["rgba(255, 255, 255, 0.02)", "transparent"]
        : ["#f8fafc", "transparent"];
      return {
        theme: { mode: escuro ? "dark" : "light" },
        chart: {
          type: "line",
          height: 400,
          toolbar: { show: false },
          background: "transparent",
          foreColor: corEixo,
        },
        colors: [escuro ? "#a78bfa" : "#4f008f", "#49A94D"],
        stroke: {
          width: [0, 3],
          curve: "smooth",
        },
        fill: {
          type: ["solid", "gradient"],
          gradient: {
            shade: escuro ? "dark" : "light",
            type: "vertical",
            shadeIntensity: 0.25,
            opacityFrom: 0.7,
            opacityTo: 0.1,
            stops: [0, 100],
          },
        },
        markers: {
          size: [0, 6],
          strokeWidth: [0, 2],
          hover: { size: 8 },
        },
        plotOptions: {
          bar: {
            columnWidth: "42%",
            borderRadius: 6,
          },
        },
        legend: {
          show: false,
        },
        dataLabels: { enabled: false },
        grid: {
          borderColor: corGrade,
          row: { colors: linhasGrade, opacity: 0.5 },
        },
        xaxis: {
          type: "category",
          categories: this.pontoCategorias,
          labels: { style: { colors: corEixo } },
          axisBorder: { show: false },
          axisTicks: { show: false },
        },
        yaxis: [
          {
            title: { text: "Registros", style: { color: escuro ? "#c4a5f5" : "#4f008f" } },
            labels: { style: { colors: corEixo } },
            min: 0,
          },
          {
            opposite: true,
            title: { text: "Dias incompletos", style: { color: "#49A94D" } },
            labels: { style: { colors: corEixo } },
            min: 0,
          },
        ],
        tooltip: {
          shared: true,
          intersect: false,
          theme: escuro ? "dark" : "light",
        },
      };
    },
  },
  data() {
    return {
      franquiaId: null,
      meuSaldo: {
        saldo_minutos: 0,
        saldo_formatado: "00:00",
        horas_positivas_fmt: "00:00",
        horas_negativas_fmt: "00:00",
        minutos_pendentes_fmt: "00:00",
      },
      saldosEquipe: [],
      saldosEquipeTotal: 0,
      totalPositivos: 0,
      totalNegativos: 0,
      totalComPendencias: 0,
      pendenciasBancoHorasTotal: 0,
      pontoRange: 10,
      pontoDados: {
        labels: [],
        batidas: [],
        incompletos: [],
      },
      tituloGrafico: "Atividade de ponto",
      pontosRangeOptions: [
        { label: "7 dias", value: 7 },
        { label: "10 dias", value: 10 },
      ],
      pontoCategorias: [],
      pontoSeries: [
        { name: "Registros", type: "column", data: [] },
        { name: "Incompletos", type: "line", data: [] },
      ],
      totalBatidasHoje: 0,
      totalDiasIncompletos: 0,
      totalFaltasJustificadas: 0,
      colaboradoresSemBatida: [],
      searchSemBatida: "",
      loadingSemBatida: false,
      avisosColaborador: [],
      colaboradorMaisPontual: null,
    };
  },
  methods: {
    async loadBancoHorasDados() {
      if (this.isAdmin && this.mostrarGestaoBancoHoras) {
        try {
          const saldosResp = await this.$services.bancoHorasService.getAdminSaldos({ limit: 100 });
          if (saldosResp && saldosResp.data) {
            this.saldosEquipe = saldosResp.data;
            this.saldosEquipeTotal = saldosResp.total || saldosResp.data.length;

            this.totalPositivos = saldosResp.data.filter(
              (item) => (item.saldo_minutos || 0) > 0
            ).length;
            this.totalNegativos = saldosResp.data.filter(
              (item) => (item.saldo_minutos || 0) < 0
            ).length;
            this.totalComPendencias = saldosResp.data.filter(
              (item) => item.minutos_pendentes_fmt && item.minutos_pendentes_fmt !== "00:00"
            ).length;
          }
        } catch (error) {
          /* eslint-disable-next-line no-console */
          console.error("Erro ao carregar saldos gerais de banco de horas:", error);
        }
      } else if (this.mostrarMeuBancoHoras) {
        try {
          const meuSaldoResp = await this.$services.bancoHorasService.getMeuSaldo();
          if (meuSaldoResp) {
            this.meuSaldo = meuSaldoResp;
          }
        } catch (error) {
          /* eslint-disable-next-line no-console */
          console.error("Erro ao carregar saldo de banco de horas:", error);
        }
      }

      if (this.mostrarGestaoBancoHoras) {
        try {
          const pendenciasResp = await this.$services.bancoHorasService.getAdminPendencias({
            page: 1,
          });
          if (pendenciasResp) {
            this.pendenciasBancoHorasTotal =
              pendenciasResp.total || (pendenciasResp.data ? pendenciasResp.data.length : 0);
          }
        } catch (error) {
          /* eslint-disable-next-line no-console */
          console.error("Erro ao carregar pendências de banco de horas:", error);
        }
      }
    },
    async loadGraficoPontos() {
      try {
        if (this.isGestor) {
          const resp = await this.$services.colaboradorPontosService.adminGraficoUltimos10Dias();
          this.pontoDados = {
            labels: this.formatarCategorias(resp.labels),
            batidas: resp.batidas,
            incompletos: resp.incompletos,
          };
          this.tituloGrafico = "Atividade de ponto — visão consolidada";

          this.totalBatidasHoje = resp.batidas[resp.batidas.length - 1] || 0;
          this.totalDiasIncompletos = resp.incompletos.reduce((a, b) => a + b, 0);

          if (this.mostrarFaltasJustificadas) {
            const faltas =
              await this.$services.colaboradorPontosService.listarTodasFaltasJustificadas({});
            this.totalFaltasJustificadas = faltas.length || 0;
          }
        } else {
          const resp = await this.$services.colaboradorPontosService.meusPontosUltimos10Dias();
          const labels = [];
          const batidas = [];
          const incompletos = [];

          for (let i = 9; i >= 0; i--) {
            const d = new Date();
            d.setDate(d.getDate() - i);
            const yyyy = d.getFullYear();
            const mm = `0${d.getMonth() + 1}`.slice(-2);
            const dd = `0${d.getDate()}`.slice(-2);
            const key = `${yyyy}-${mm}-${dd}`;
            const items = resp[key] || [];
            labels.push(`${dd}/${mm}`);
            batidas.push(items.length || 0);
            incompletos.push(items.length % 2 === 1 ? 1 : 0);
          }

          this.pontoDados = { labels, batidas, incompletos };
          this.tituloGrafico = "Meu ponto — últimos 10 dias";

          this.totalBatidasHoje = batidas[batidas.length - 1] || 0;
          this.totalDiasIncompletos = incompletos.reduce((a, b) => a + b, 0);
        }
        this.aplicarRangePonto();
      } catch (error) {
        this.$handleError(error);
      }
    },
    aplicarRangePonto() {
      const dias = this.pontoRange;
      const dados = this.pontoDados || { labels: [], batidas: [], incompletos: [] };
      const batidas = (dados.batidas || []).slice();
      const labels = (dados.labels || []).slice();
      const incompletos = (dados.incompletos || []).slice();

      const offset = Math.max(0, labels.length - dias);
      const batidasFiltradas = labels.length > 0 ? batidas.slice(offset) : batidas;
      const incompletosFiltrados = labels.length > 0 ? incompletos.slice(offset) : incompletos;
      const labelsFiltrados = labels.length > 0 ? labels.slice(offset) : labels;

      this.pontoSeries = [
        { name: "Registros", type: "column", data: batidasFiltradas },
        { name: "Incompletos", type: "line", data: incompletosFiltrados },
      ];

      this.pontoCategorias = labelsFiltrados;
    },
    selecionarRangePonto(dias) {
      this.pontoRange = dias;
      this.aplicarRangePonto();
    },
    async loadColaboradoresSemBatida() {
      this.loadingSemBatida = true;
      try {
        this.colaboradoresSemBatida =
          await this.$services.colaboradorPontosService.colaboradoresSemBatidaHoje();
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.loadingSemBatida = false;
      }
    },
    formatarCategorias(labels = []) {
      return labels.map((d) => {
        if (!d) return "";
        const clean = String(d).split(" ")[0];
        const parts = clean.split("-");
        if (parts.length < 3) return d;
        return `${parts[2]}/${parts[1]}`;
      });
    },
    async loadAvisosColaborador() {
      try {
        const res = await this.$services.colaboradorAvisoService.listarAvisosColaborador();
        this.avisosColaborador = res.data || [];
      } catch (error) {
        /* eslint-disable-next-line no-console */
        console.error("Erro ao carregar avisos:", error);
      }
    },
    async loadColaboradorMaisPontual() {
      try {
        this.colaboradorMaisPontual =
          await this.$services.colaboradorPontosService.colaboradorMaisPontual();
      } catch (error) {
        /* eslint-disable-next-line no-console */
        console.error("Erro ao carregar destaque da semana:", error);
      }
    },
    obterUrlImagemAviso(path) {
      if (!path) return "";
      const filename = path.split("/").pop();
      const token = localStorage.getItem("access_token") || "";
      return `${process.env.VUE_APP_API_HOST}colaborador-avisos/uploads/${filename}?token=${token}`;
    },
  },
};
</script>

<style scoped>
/* Tons locais da página: claro por padrão, sobrescritos no modo escuro. */
.home-page {
  --home-inset: rgba(255, 255, 255, 0.9);
  --home-metric-bg: rgba(255, 255, 255, 0.85);
  --tint-green: #ecfdf3;
  --tint-green-soft: #f0fdf4;
  --tint-amber: #fffbeb;
  --tint-amber-border: #fde68a;
  --tint-gold: #fffdf5;
  --tint-orange-soft: #fff3e0;
  --tint-rose: #fff1f2;
  --tint-rose-soft: #fff5f6;
  --fg-green: #15803d;
  --fg-amber: #d97706;
  --fg-amber-strong: #b45309;
}

.theme--dark .home-page {
  --home-inset: rgba(255, 255, 255, 0.04);
  --home-metric-bg: rgba(255, 255, 255, 0.04);
  --tint-green: rgba(34, 197, 94, 0.16);
  --tint-green-soft: #1c2829;
  --tint-amber: rgba(245, 158, 11, 0.16);
  --tint-amber-border: rgba(251, 191, 36, 0.35);
  --tint-gold: #292222;
  --tint-orange-soft: #2d2221;
  --tint-rose: rgba(244, 63, 94, 0.16);
  --tint-rose-soft: rgba(244, 63, 94, 0.08);
  --fg-green: #4ade80;
  --fg-amber: #fbbf24;
  --fg-amber-strong: #fbbf24;
}
.page-title {
  font-size: 22px;
  line-height: 1.2;
}

.page-subtitle {
  font-size: 14px;
  line-height: 1.4;
}

@media (min-width: 600px) {
  .page-title {
    font-size: 28px;
  }
}

.role-pill {
  letter-spacing: 0.2px;
}

.min-w-0 {
  min-width: 0;
}

.page-icon-avatar,
.chart-icon-avatar,
.card-icon-avatar {
  box-shadow: 0 2px 8px rgba(79, 0, 143, 0.12);
}

.badge-gradient {
  background: linear-gradient(135deg, #4f008f 0%, #7c3aed 100%) !important;
  box-shadow: 0 6px 16px rgba(79, 0, 143, 0.35) !important;
}

.badge-gradient .v-icon {
  color: #ffffff !important;
}

.badge-gradient-rose {
  background: linear-gradient(135deg, #f43f5e 0%, #fb7185 100%) !important;
  box-shadow: 0 6px 16px rgba(244, 63, 94, 0.35) !important;
}

.card-hover {
  transition: transform 0.18s ease, box-shadow 0.18s ease;
}

.card-hover:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 28px rgba(15, 23, 42, 0.08) !important;
}

.hero-banco-card {
  border-color: var(--border);
  background: linear-gradient(135deg, var(--surface) 0%, var(--brand-soft) 100%);
  box-shadow: 0 8px 24px rgba(79, 0, 143, 0.05);
}

.hero-gestao-card {
  border-color: var(--border);
  background: linear-gradient(135deg, var(--surface) 0%, var(--tint-gold) 100%);
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.04);
}

.saldo-panel {
  border: 1px solid var(--border);
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.05);
}

.saldo-panel-geral {
  background: linear-gradient(135deg, var(--surface) 0%, var(--brand-soft) 100%);
  border-left: 4px solid var(--brand);
}

.saldo-panel-positivo {
  background: linear-gradient(135deg, var(--surface) 0%, var(--tint-green-soft) 100%);
  border-left: 4px solid #49a94d;
}

.saldo-panel-negativo {
  background: linear-gradient(135deg, var(--surface) 0%, var(--tint-orange-soft) 100%);
  border-left: 4px solid #f57c00;
}

.saldo-panel-content {
  position: relative;
  z-index: 1;
}

.saldo-panel-icon,
.pendencias-panel-icon {
  position: absolute;
  right: -8px;
  bottom: -10px;
  font-size: 120px !important;
  opacity: 0.12;
  pointer-events: none;
}

.saldo-stats {
  border-top: 1px solid var(--border);
}

.saldo-stat-label {
  font-size: 11.5px;
  text-transform: uppercase;
  font-weight: 700;
  letter-spacing: 0.2px;
  color: var(--text-muted);
}

.saldo-stat-value {
  font-size: 17px;
  font-weight: 800;
  margin-top: 3px;
}

.saldo-stat-divider {
  width: 1px;
  height: 34px;
  background: var(--border);
}

.hero-panel-hint {
  font-size: 12px;
  font-weight: 500;
  color: var(--text-muted);
}

.hero-panel-msg {
  font-size: 12px;
  color: var(--text-3);
  font-style: italic;
  line-height: 1.45;
}

.pendencias-panel {
  border: 1px solid var(--tint-amber-border);
  background: linear-gradient(135deg, var(--surface) 0%, var(--tint-gold) 100%);
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.05);
}

.pendencias-panel-content {
  position: relative;
  z-index: 1;
}

.gestao-action-btn {
  height: 44px !important;
}

.chart-card {
  position: relative;
  overflow: hidden;
  border-color: var(--border);
  box-shadow: inset 0 1px 0 var(--home-inset), 0 10px 30px rgba(15, 23, 42, 0.05);
}

.chart-card::before {
  content: "";
  position: absolute;
  top: -80px;
  right: -60px;
  width: 200px;
  height: 200px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(124, 58, 237, 0.12), transparent 70%);
  pointer-events: none;
}

.chart-card > .v-card__title,
.chart-card > .v-card__text {
  position: relative;
  z-index: 1;
}

.chart-header {
  min-height: 0;
}

.range-chip {
  letter-spacing: 0.3px;
  cursor: pointer;
}

.chart-legend {
  column-gap: 28px;
  row-gap: 8px;
  flex-wrap: wrap;
}

.chart-legend-item {
  display: inline-flex;
  align-items: center;
  font-size: 12.5px;
  font-weight: 600;
  color: var(--text-3);
}

.legend-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 6px;
  display: inline-block;
}

.metric-card {
  --accent: #4f008f;
  --accent-end: #7c3aed;
  --accent-text: var(--brand);
  --accent-text-end: var(--brand-3);
  --tone-orb: rgba(124, 58, 237, 0.16);
  position: relative;
  overflow: hidden;
  border-color: var(--border);
  box-shadow: inset 0 1px 0 var(--home-inset), 0 10px 30px rgba(15, 23, 42, 0.06);
  transition: transform 0.18s ease, box-shadow 0.18s ease, border-color 0.18s ease;
}

.metric-card::before {
  content: "";
  position: absolute;
  top: -70px;
  right: -55px;
  width: 180px;
  height: 180px;
  border-radius: 50%;
  background: radial-gradient(circle, var(--tone-orb), transparent 70%);
  pointer-events: none;
}

.metric-card:hover {
  transform: translateY(-3px);
  box-shadow: inset 0 1px 0 var(--home-inset), 0 14px 30px rgba(15, 23, 42, 0.1);
  border-color: var(--brand-border) !important;
}

.metric-tone-registros {
  --accent: #4f008f;
  --accent-end: #7c3aed;
  --accent-text: var(--brand);
  --accent-text-end: var(--brand-3);
  --tone-orb: rgba(124, 58, 237, 0.18);
}

.metric-tone-incompletos {
  --accent: #3f9d4d;
  --accent-end: #22c55e;
  --tone-orb: rgba(73, 169, 77, 0.18);
}

.metric-tone-faltas {
  --accent: #059669;
  --accent-end: #34d399;
  --tone-orb: rgba(16, 185, 129, 0.16);
}

.metric-tone-destaque {
  --accent: #d97706;
  --accent-end: #f59e0b;
  --tone-orb: rgba(255, 179, 0, 0.22);
  border-color: rgba(251, 191, 36, 0.5) !important;
  background: linear-gradient(160deg, var(--surface) 0%, var(--tint-gold) 100%);
}

.metric-tone-destaque:hover {
  border-color: rgba(251, 191, 36, 0.75) !important;
}

.metric-card > .d-flex {
  position: relative;
  z-index: 1;
}

.metric-label {
  font-size: 11px;
  text-transform: uppercase;
  font-weight: 700;
  letter-spacing: 0.4px;
  color: var(--text-muted);
}

.metric-value {
  font-size: 30px;
  font-weight: 900;
  line-height: 1.15;
  margin-top: 6px;
  letter-spacing: -0.5px;
  background-image: linear-gradient(
    135deg,
    var(--accent-text, var(--accent)),
    var(--accent-text-end, var(--accent-end))
  );
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  color: transparent;
}

.metric-badge {
  width: 48px;
  height: 48px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: #ffffff;
  background: linear-gradient(135deg, var(--accent), var(--accent-end));
  box-shadow: 0 6px 16px rgba(15, 23, 42, 0.16);
}

.metric-badge .v-icon {
  color: #ffffff !important;
}

.metric-label-destaque {
  display: flex;
  align-items: center;
  gap: 4px;
  color: var(--fg-amber-strong) !important;
}

.metric-label-destaque .v-icon {
  color: #d97706 !important;
}

.metric-value-name {
  font-size: 17px;
  font-weight: 800;
  color: var(--text-2);
  line-height: 1.2;
  margin-top: 6px;
}

.metric-sub {
  font-size: 12px;
  font-weight: 600;
  color: var(--fg-green);
  margin-top: 2px;
}

.collab-card {
  position: relative;
  overflow: hidden;
  border-color: var(--border);
  box-shadow: inset 0 1px 0 var(--home-inset), 0 10px 30px rgba(15, 23, 42, 0.05);
}

.collab-card::before {
  content: "";
  position: absolute;
  top: -90px;
  right: -70px;
  width: 220px;
  height: 220px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(244, 63, 94, 0.1), transparent 70%);
  pointer-events: none;
}

.collab-card .v-card__title,
.collab-card .v-card__text {
  position: relative;
  z-index: 1;
}

.colab-item-card {
  border-color: var(--border-soft);
  background-color: var(--surface);
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.04);
  transition: transform 0.18s ease, box-shadow 0.18s ease, border-color 0.18s ease;
}

.colab-item-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 18px rgba(244, 63, 94, 0.14);
  border-color: #fda4af;
  background-color: var(--tint-rose-soft);
}

.search-input >>> .v-input__control >>> .v-input__slot {
  background-color: var(--surface-2) !important;
}

.cursor-pointer {
  cursor: pointer;
}

.hero-value {
  font-size: 24px;
  line-height: 1.2;
}

@media (min-width: 600px) {
  .hero-value {
    font-size: 30px;
  }
}

@media (min-width: 960px) {
  .hero-value {
    font-size: 34px;
  }
}

@media (max-width: 599px) {
  .hero-card {
    margin-bottom: 16px;
  }
  .v-row > .v-col:last-child .hero-card {
    margin-bottom: 0;
  }
  .saldo-stats {
    padding-top: 12px;
  }
  .hero-panel-msg {
    padding-top: 10px;
  }
  .saldo-stat-value {
    font-size: 15px;
  }
  .saldo-stat-divider {
    margin-left: 12px !important;
    margin-right: 12px !important;
  }
  .saldo-panel-icon,
  .pendencias-panel-icon {
    font-size: 90px !important;
    right: -6px;
    bottom: -8px;
  }
  .saldo-panel-content,
  .pendencias-panel-content {
    gap: 12px;
  }
}

.summary-row {
  display: grid;
  grid-template-columns: 1fr;
  gap: 24px;
  margin-bottom: 24px;
}

.summary-card {
  position: relative;
  display: flex;
  flex-direction: column;
  border-color: var(--border);
  box-shadow: inset 0 1px 0 var(--home-inset), 0 10px 30px rgba(15, 23, 42, 0.06);
  overflow: hidden;
  transition: transform 0.18s ease, box-shadow 0.18s ease;
}

.summary-card::before,
.summary-card::after {
  content: "";
  position: absolute;
  border-radius: 50%;
  pointer-events: none;
}

.summary-card::before {
  top: -90px;
  right: -70px;
  width: 240px;
  height: 240px;
}

.summary-card::after {
  bottom: -80px;
  left: -60px;
  width: 200px;
  height: 200px;
}

.summary-type-bank::before {
  background: radial-gradient(circle, rgba(124, 58, 237, 0.18), transparent 70%);
}

.summary-type-gestao::before {
  background: radial-gradient(circle, rgba(251, 191, 36, 0.22), transparent 70%);
}

.summary-type-bank::after {
  background: radial-gradient(circle, rgba(79, 0, 143, 0.07), transparent 70%);
}

.summary-type-gestao::after {
  background: radial-gradient(circle, rgba(245, 124, 0, 0.08), transparent 70%);
}

.summary-card:hover {
  transform: translateY(-2px);
  box-shadow: inset 0 1px 0 var(--home-inset), 0 16px 34px rgba(15, 23, 42, 0.1);
}

.summary-body {
  position: relative;
  z-index: 1;
}

.summary-type-bank {
  background: linear-gradient(160deg, var(--surface) 0%, var(--brand-soft) 100%);
}

.summary-type-gestao {
  background: linear-gradient(160deg, var(--surface) 0%, var(--tint-gold) 100%);
}

.summary-accent {
  height: 6px;
  flex-shrink: 0;
  position: relative;
  z-index: 1;
}

.summary-type-bank .summary-accent {
  background: linear-gradient(90deg, #4f008f 0%, #7c3aed 60%, #a855f7 100%);
}

.summary-type-gestao .summary-accent {
  background: linear-gradient(90deg, #f57c00 0%, #fbbf24 60%, #ffd54f 100%);
}

.summary-header {
  gap: 12px;
}

.summary-badge {
  width: 48px;
  height: 48px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
  color: #ffffff;
}

.summary-type-bank .summary-badge {
  background: linear-gradient(135deg, #4f008f 0%, #7c3aed 100%);
  box-shadow: 0 6px 16px rgba(79, 0, 143, 0.35);
}

.summary-type-gestao .summary-badge {
  background: linear-gradient(135deg, #f57c00 0%, #fbbf24 100%);
  box-shadow: 0 6px 16px rgba(245, 124, 0, 0.35);
}

.summary-title {
  font-size: 17px;
  font-weight: 700;
  color: var(--text);
  line-height: 1.25;
  letter-spacing: 0.2px;
}

.summary-subtitle {
  font-size: 12.5px;
  color: var(--text-muted);
  line-height: 1.35;
  margin-top: 2px;
}

.summary-pill {
  letter-spacing: 0.2px;
}

.summary-hero-label {
  font-size: 11.5px;
  text-transform: uppercase;
  font-weight: 700;
  letter-spacing: 0.6px;
  color: var(--text-muted);
}

.summary-hero-label::before {
  content: "";
  display: inline-block;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  margin-right: 7px;
  vertical-align: middle;
  background: #7c3aed;
}

.summary-type-gestao .summary-hero-label::before {
  background: #f59e0b;
}

.summary-hero-value {
  font-size: 40px;
  font-weight: 900;
  line-height: 1.15;
  margin-top: 4px;
  word-break: break-word;
  letter-spacing: -0.5px;
}

.summary-hero-value.is-amber {
  color: #f57c00;
  -webkit-text-fill-color: #f57c00;
}

.summary-hero-value.is-green {
  color: var(--fg-green);
  -webkit-text-fill-color: var(--fg-green);
}

.summary-hero-value.is-orange {
  color: #ea580c;
  -webkit-text-fill-color: #ea580c;
}

.summary-type-bank .summary-hero-value {
  background-image: linear-gradient(135deg, var(--brand) 0%, var(--brand-3) 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  color: transparent;
}

.summary-type-gestao .summary-hero-value {
  background-image: linear-gradient(135deg, #d97706 0%, #f59e0b 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  color: transparent;
}

.summary-hero-caption {
  font-size: 12.5px;
  color: var(--text-3);
  line-height: 1.45;
  margin-top: 6px;
}

.summary-metrics {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
  margin-top: 18px;
}

.summary-metric {
  display: flex;
  align-items: center;
  gap: 10px;
  background: var(--home-metric-bg);
  border: 1px solid var(--border-soft);
  border-radius: 12px;
  padding: 12px;
  min-width: 0;
  box-shadow: 0 2px 6px rgba(15, 23, 42, 0.03);
  transition: transform 0.18s ease, box-shadow 0.18s ease, border-color 0.18s ease;
}

.summary-metric:hover {
  transform: translateY(-1px);
  box-shadow: 0 8px 18px rgba(15, 23, 42, 0.08);
  border-color: var(--border);
}

.summary-type-gestao .summary-metric {
  background: var(--surface);
}

.summary-metric-icon {
  width: 30px;
  height: 30px;
  border-radius: 9px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.summary-metric-icon .v-icon {
  font-size: 16px !important;
}

.summary-metric-icon.is-green {
  background: var(--tint-green);
  color: var(--fg-green);
}

.summary-metric-icon.is-amber {
  background: var(--tint-amber);
  color: #f57c00;
}

.summary-metric-label {
  font-size: 11px;
  text-transform: uppercase;
  font-weight: 700;
  letter-spacing: 0.2px;
  color: var(--text-muted);
  line-height: 1.3;
}

.summary-metric-value {
  font-size: 15px;
  font-weight: 800;
  color: var(--text-2);
  margin-top: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.summary-metric-value.is-green {
  color: var(--fg-green);
}

.summary-metric-value.is-amber {
  color: var(--fg-amber);
}

.summary-footer {
  margin-top: auto;
  padding-top: 18px;
  border-top: 1px dashed var(--border);
  display: flex;
  align-items: center;
  font-size: 12px;
  font-weight: 500;
  color: var(--text-muted);
  line-height: 1.45;
}

.gestao-action-btn {
  transition: transform 0.18s ease, box-shadow 0.18s ease !important;
}

.gestao-action-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 10px 22px rgba(79, 0, 143, 0.3) !important;
}

.summary-type-bank .gestao-action-btn {
  background: linear-gradient(135deg, #4f008f 0%, #6d28d9 100%) !important;
  border-color: transparent !important;
  box-shadow: 0 6px 16px rgba(79, 0, 143, 0.28) !important;
}

.summary-type-gestao .gestao-action-btn {
  background: linear-gradient(135deg, #d97706 0%, #f59e0b 100%) !important;
  border-color: transparent !important;
  box-shadow: 0 6px 16px rgba(245, 158, 11, 0.3) !important;
}

.summary-type-gestao .gestao-action-btn:hover {
  box-shadow: 0 10px 22px rgba(245, 158, 11, 0.38) !important;
}

@media (min-width: 600px) and (max-width: 1263px) {
  .summary-hero-value {
    font-size: 34px;
  }
}

@media (min-width: 1264px) {
  .summary-row {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .summary-row .summary-card:only-child {
    grid-column: 1 / -1;
  }
}

@media (max-width: 599px) {
  .summary-body {
    padding: 16px !important;
  }
  .summary-hero-value {
    font-size: 30px;
  }
  .summary-title {
    font-size: 15.5px;
  }
  .summary-badge {
    width: 42px;
    height: 42px;
  }
  .summary-metric {
    gap: 8px;
    padding: 10px;
  }
  .summary-metric-label {
    font-size: 10px;
  }
  .summary-metric-value {
    white-space: normal;
    word-break: break-word;
    font-size: 14px;
  }
}

.animate-item {
  animation: fadeUp 0.6s cubic-bezier(0.22, 0.9, 0.35, 1) both;
}

.home-page > .a1 {
  animation-delay: 0.05s;
}
.home-page > .a2 {
  animation-delay: 0.14s;
}
.home-page > .a3 {
  animation-delay: 0.24s;
}
.home-page > .a4 {
  animation-delay: 0.34s;
}
.home-page > .a5 {
  animation-delay: 0.44s;
}

.metrics-row .v-col {
  animation: fadeUp 0.55s cubic-bezier(0.22, 0.9, 0.35, 1) both;
}

.metrics-row .v-col:nth-child(1) {
  animation-delay: 0.38s;
}
.metrics-row .v-col:nth-child(2) {
  animation-delay: 0.46s;
}
.metrics-row .v-col:nth-child(3) {
  animation-delay: 0.54s;
}
.metrics-row .v-col:nth-child(4) {
  animation-delay: 0.62s;
}

@keyframes fadeUp {
  from {
    opacity: 0;
    transform: translateY(22px) scale(0.99);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

@keyframes floatOrb {
  0%,
  100% {
    transform: translate(0, 0);
  }
  50% {
    transform: translate(-10px, 12px);
  }
}

.summary-card::before,
.summary-card::after,
.metric-card::before,
.chart-card::before,
.collab-card::before {
  animation: floatOrb 9s ease-in-out infinite;
}

.aviso-banner {
  background-image: linear-gradient(120deg, #4f008f 0%, #6d28d9 45%, #4f008f 100%) !important;
}

.aviso-banner::before {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(
    105deg,
    transparent 30%,
    rgba(255, 255, 255, 0.1) 45%,
    rgba(255, 255, 255, 0.18) 50%,
    rgba(255, 255, 255, 0.1) 55%,
    transparent 70%
  );
  transform: translateX(-120%);
  animation: sheen 5.5s ease-in-out infinite;
}

.aviso-banner::after {
  content: "";
  position: absolute;
  top: -60px;
  right: -60px;
  width: 190px;
  height: 190px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(255, 255, 255, 0.22), transparent 70%);
  pointer-events: none;
}

.aviso-banner .d-flex {
  position: relative;
  z-index: 1;
}

@keyframes sheen {
  0% {
    transform: translateX(-120%);
  }
  45%,
  100% {
    transform: translateX(120%);
  }
}

@media (prefers-reduced-motion: reduce) {
  .animate-item,
  .metrics-row .v-col,
  .summary-card::before,
  .summary-card::after,
  .metric-card::before,
  .chart-card::before,
  .collab-card::before,
  .aviso-banner::before {
    animation: none !important;
  }
}
</style>
